<template>
  <v-dialog
    v-model="dialog"
    max-width="650px"
  >
    <template v-slot:activator="{ on: dialog }">
      <v-tooltip bottom>
        <template v-slot:activator="{ on: tooltip }">
          <v-btn
            :color="leaveApplication.status.id === 100 && statusFilterId === 100 ? 'success' : 'primary'" 
            icon
            v-on="{ ...dialog, ...tooltip }"
          >
            <v-icon>
              {{ leaveApplication.status.id === 100 && statusFilterId === 100 ? 'mdi-gesture-tap-hold' : 'mdi-eye' }}
            </v-icon>
          </v-btn>
        </template>
      
        <span> {{ leaveApplication.status.id === 100 && statusFilterId === 100 ? 'Update Approval' : 'View Approval' }}</span>
      </v-tooltip>
    </template>
   
    <material-card
      :offset="10"
      :full-width="true"
      :loading="loading"
      color="hrissecondary"
      title="Leave Approval"
      :text="(leaveApplication.status.id === 100 && statusFilterId === 100 ? 'Update' : 'View') + ' Leave Approval Status'"
      class="mb-0"
    >
      <template v-if="dialog && !loading">
        <v-container
          :style="{ height: containerHeight}"
          data-simplebar
        >
          <v-row dense>
            <v-col cols="12">
              Requester: <span class="font-weight-bold"> {{ person.name }} </span>
            </v-col>
            <v-col cols="12">
              Leave Type: <span class="font-weight-bold"> {{ leaveType.name }} </span>
              <employee-leaves-entitlements-popover-details-view :leave-entitlement="leaveEntitlement" />
            </v-col>
            <v-col cols="12">
              Reason: <span class="font-weight-bold"> {{ leaveApplication.reason }} </span>
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-icon
                    v-if="leaveType.id === 19 && ($moment(leaveApplication.leave_days[0].date).format('MM-DD') !== $moment(person.dob).format('MM-DD'))"
                    color="red"
                    v-on="on"
                  >
                    mdi-information-outline
                  </v-icon>
                </template>
                Actual birthday is on  {{ $moment(person.dob).format('D MMMM') }}
              </v-tooltip>
            </v-col>
            <v-col cols="12">
              Available Days: <span class="font-weight-bold"> {{ roundLeave(leaveEntitlement.available_days) }} </span>
            </v-col>
      
            <v-col
              cols="12"
            >
              <v-row>
                <v-col
                  cols="3"
                  class="py-0 pr-0"
                >
                  Requested Days:
                </v-col>
                <v-col
                  cols="9"
                  class="py-0 pl-0 ml-n8"
                >
                  <div
                    v-for="item in leaveApplication.leave_days"
                    :key="item.id"
                    class="font-weight-bold"
                  >
                    {{ $moment(item.date).format('D MMMM YYYY') }} ({{ $moment(item.date).format('dddd') }}) - {{ item.leave_session.name }}
                  </div> 
                </v-col>
              </v-row>
            </v-col>

            <v-col cols="12">
              Total Requested Days: <span class="font-weight-bold"> {{ leaveApplication.requested_days }} </span>
            </v-col>

            <v-col cols="12">
              <v-row dense>
                <v-col cols="4">
                  Start Date: <span class="font-weight-bold"> {{ leaveApplication.start_date }} </span>
                </v-col>
                <v-col cols="4">
                  End Date: <span class="font-weight-bold"> {{ leaveApplication.end_date }} </span>
                </v-col>              
              </v-row>
            </v-col>              
            <v-col cols="12">
              <v-row>
                <v-col
                  v-for="document in leaveApplication.documents"
                  :key="document.id"
                  cols="6"
                  class="px-1 py-2"
                >
                  <v-chip
                    color="blue-grey lighten-3"
                    link
                    :href="document.file_url"
                    target="_blank"
                  >
                    <v-icon
                      color="red"
                      left
                    >
                      mdi-file-image
                    </v-icon>
                    <span class="text-truncate"> {{ document.file_name }} </span>
                  </v-chip>
                </v-col> 
              </v-row>
            </v-col>          
          </v-row>                 
          <template>            
            <v-divider />   
            <v-card-title class="pl-0">
              Subordinate On Leave 
            </v-card-title>
            <v-row
              v-if="noOfCoworkers > 0"
              dense
            >  
              <v-col cols="12">                
                <employee-leaves-applications-approvals-coworker-popover-card 
                  v-for="(coworker, i) in minCoworkers"
                  :key="i"
                  :employee="coworker"
                  :city="coworker.city"
                  :leave-applications="coworker.leave_applications"
                />              
              </v-col>
              <div v-if="noOfCoworkers >= 15">
                <a 
                  v-if="filter" 
                  @click.stop="filter = false"
                >Show more ...</a> 
                <a 
                  v-else 
                  @click.stop="filter = true"
                >Show less ...</a>
              </div>
            </v-row>
            <span
              v-else
              class="pl-4"
            > No coworkers on leave </span>
          </template>
          <template v-if="approvals.length > 0">
            <v-card-title class="pl-0 pb-0">
              Approval History
            </v-card-title>
            <v-row
              v-for="(item, i) in approvals"
              :key="i"
              no-gutters
            >              
              <v-col cols="12">
                <v-list
                  three-line
                  class="py-0"
                >
                  <v-list-item>
                    <v-list-item-avatar size="55">
                      <v-img :src="item.approver ? item.approver.thumbnail_url : defaultAvatar" />
                    </v-list-item-avatar>

                    <v-list-item-content>
                      <v-list-item-title class="body-1"> 
                        <v-icon
                          :class="{
                            'warning--text': item.status.id === 100,
                            'red--text': item.status.id === 500,
                            'green--text': item.status.id === 200 || item.status.id === 201
                          }"
                          x-small
                        >
                          mdi-checkbox-blank-circle
                        </v-icon>
                        {{ item.approver ? item.approver.person.name : item.approver_name }} 
                      </v-list-item-title>
                      <v-list-item-subtitle class="body-2">
                        {{ $moment(item.updated_at).format('D MMMM YYYY') }}
                      </v-list-item-subtitle>
                      <v-list-item-subtitle> Remark: {{ item.remark }} </v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>
                </v-list>
              </v-col>
            </v-row>
          </template>
        </v-container>
        <form v-if="isSubordinates || $hasPermissionTo(['approve leave on behalf'])">
          <v-container class="py-0">
            <v-row no-gutters>
              <v-divider class="mt-4 mx-0" />
              <v-col
                v-if="leaveApplication.status.id===100"
                cols="12"
              >
                <v-radio-group
                  v-model="selectedStatus"
                  v-validate="'required'"
                  :error-messages="errors.collect('selectedStatus')"
                  data-vv-name="selectedStatus"        
                  data-vv-as="status"        
                  row
                >
                  <v-radio
                    v-for="item in status"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  />
                </v-radio-group>
              </v-col>
              <v-col
                v-if="selectedStatus === 500"
                cols="12"
              >
                <v-textarea
                  v-model="remark"
                  v-validate="selectedStatus === 200?'':'required|max:2000'"
                  :rows="2"
                  :error-messages="errors.collect('remark')"
                  data-vv-name="remark"        
                  label="Remark"
                />
              </v-col>
            </v-row>
          </v-container>
        </form>
      </template>
      <v-card-actions v-if="leaveApplication.status.id === 100 && statusFilterId === 100">
        <v-spacer />
        <v-btn
          :disabled="progressing"
          text
          @click="dialog = false"
        >
          Close
        </v-btn>
        <v-btn
          v-if="isSubordinates || $hasPermissionTo(['approve leave on behalf'])"
          :loading="progressing"
          :disabled="loading"
          color="hrissecondary"
          class="white--text"
          @click="submitForm"
        >
          Update Status
        </v-btn>
      </v-card-actions>
    </material-card>
  </v-dialog>
</template>

<script>
  import { mapState, mapMutations } from 'vuex'
  export default {
    components: {
      EmployeeLeavesEntitlementsPopoverDetailsView: () => import('@/components/employee/leaves/entitlements/PopoverDetailsView'),
      EmployeeLeavesApplicationsApprovalsCoworkerPopoverCard: () => import('@/components/employee/leaves/applications/approvals/CoworkerPopoverCard'),
    },
    $_veeValidate: {
      validator: 'new', 
    },
    props: {
      employeeUid: {
        type: String,
        required: true,
      },
      leaveApplication: {
        type: Object,
        required: true,
      },
      isSubordinates: {
        type: Boolean,
        default: false,
      },
      statusFilterId: {
        type: Number,
        required: true,
      },
    },  
    data () {
      return {
        dialog: null,
        loading: false,
        progressing: false,
        approvals: [],
        coWorkers: [],
        status: [
          {
            id: 200,
            name: 'Approve',
          },
          {
            id: 500,
            name: 'Reject',
          },
        ],
        selectedStatus: null,
        remark: null,
        filter: true,
        defaultAvatar: 'img/thumbnail.jpg',
      }
    },
    computed: {
      ...mapState(['currentEmployee']),
      containerHeight () {
        if (this.noOfCoworkers > 0 && this.noOfApprovals > 0) return '55vh'
        
        if (this.noOfApprovals > 0 || this.noOfCoworkers > 0) return '50vh'

        return '40vh'
      },
      minCoworkers () {
        if (this.noOfCoworkers < 15) return this.coWorkers

        return this.filter ? this.coWorkers.slice(0, 14) : this.coWorkers
      },
      noOfCoworkers () {
        return this.coWorkers.length
      },
      noOfApprovals () {
        return this.approvals.length
      },
      leaveType () {
        return this.leaveEntitlement.leave_type || {}
      },
      approvalRequest () {
        return this.leaveApplication.approval_request || {}
      },
      leaveEntitlement () {
        return this.leaveApplication.leave_entitlement || {}
      },
      approval () {
        return this.leaveApplication.approval || {}
      },
      person () {
        return this.employee.person || {}
      },
      employee () {
        return this.leaveApplication.employee || {}
      },
    },
    watch: {
      dialog (value) {
        if (value) {
          this.loadData()
        } else {
          this.$resetData()
        }
      },
    },
    methods: {
      ...mapMutations('app', ['setPendingCount']),
      roundLeave (days) {
        return (days - Math.floor(days)) >= 0.5 ? Math.floor(days) + 0.5 : Math.floor(days)
      },

      loadData () {
        this.loading = true
        
        Promise.all([
          this.loadApprovals(),
          this.loadCoworkers(),
        ]).then(([approval, coworkers]) => {
          this.approvals = approval.data
    
          this.coWorkers = this.getCoworkersOnLeave(coworkers.data.filter(coworker => coworker.employee_uid !== this.leaveApplication.leave_entitlement.employee_uid))
          
          this.loading = false
        })
      },
      submitForm () {
        if (this.progressing) return

        this.progressing = true

        this.$validator.validateAll()
          .then(result => {
            if (!result) {
              this.progressing = false
              return
            }

            this.update()
              .then(response => {
                this.$emit('updated')
                this.$snack({ message: response.data.status })

                this.$api.leaveApprovals().pendingCount()
                  .then(response => {
                    this.setPendingCount(response.data)
                  })
                  .catch(() => {})

                this.dialog = false
              })
              .catch(() => {})
              .then(() => {
                this.progressing = false
              })
          })
      },
      update () {
        return this.selectedStatus === 200 ? this.approve() : this.reject()
      },
      getCoworkersOnLeave (coworkers) {
        return coworkers.filter(coworker => {
          const validApplications = coworker.leave_applications.filter(leaveApplication => {
            return leaveApplication.leave_days.some(leaveDay => {
              return this.$moment(leaveDay.date).isBetween(
                this.leaveApplication.start_date, 
                this.leaveApplication.end_date,
                null,
                []
              )
            })
          })

          if (validApplications.length > 0) {
            coworker.leave_applications = validApplications
            return true
          }

          return false
        })
      },
      approve () {
        return this.$api.leaveApprovals().approve(this.approval.id, { remark: 'Approved - by System' })
      },
      reject () {
        return this.$api.leaveApprovals().reject(this.approval.id, { remark: this.remark })
      },
      loadApprovals () {
        return this.$api.leaveRequestApprovals().list(this.approvalRequest.id)
      },
      loadCoworkers () {
        return this.$api.coworkerWithLeaves().subordinateOnLeave(this.leaveApplication.leave_entitlement.employee_uid, this.prepareFormData())
      },
      prepareFormData () {
        return {
          start_date: this.leaveApplication.start_date, 
          end_date: this.leaveApplication.end_date,
        }   
      },
    },
  }
</script>

<style lang="css" scoped>
  .overflow {
    height:35vh;
  }

  .leavedays{
      padding-left:110px !important
  }
</style>
